<template>
  <v-card>
    <v-card-title>
      <v-icon
        class="mr-6"
        color="primary"
        large
      >
        mdi mdi-microsoft-outlook
      </v-icon>
      <span class="subtitle-1 text-uppercase">Microsoft 360 / Outlook</span>
    </v-card-title>
    <v-card-text>
      <p class="body-2 black--text">Your connection with Microsoft 360 and Outlook has expired. To reconnect click on the button below.</p>
      <div class="actions-container pt-4">
        <v-btn
          class="mb-4"
          color="primary"
          :to="getAccountRoute({ name: 'user-apps' })"
          :disabled="loading"
          @click="$emit('outlook:processed')"
        >
          Open Settings
        </v-btn>
        <v-btn
          class="grey--text"
          text
          :loading="loading"
          @click="removeUserIntegration"
        >
          Remove my connection to Outlook
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { mapActions, mapMutations, mapState } from 'vuex';
import mixins from 'vue-typed-mixins';

import { AccountLayoutMixin } from '@/bundles/App/mixins/accountMixin';
import { NotificationMutations } from '@/store/types/mutation-types';
import { ServiceFactory } from '@/services/ServiceFactory';
import { RootActions } from '@/store/types/action-types';

const integrationService = ServiceFactory.get('integrations');

export default mixins(AccountLayoutMixin).extend({
  name: 'MemberOutlookExpired',

  data: (): { loading: boolean } => ({
    loading: false,
  }),

  computed: {
    ...mapState({
      user: (state: any) => state.user,
      integrations: (state: any) => state.userIntegrations,
      token: (state: any) => state.idToken,
    }),
    outlook: {
      get: function (): any {
        return this.integrations.find((integration) => integration.name === 'outlook');
      },
    },
  },

  methods: {
    ...mapActions({
      fetchUserIntegrations: RootActions.FETCH_USER_INTEGRATIONS,
    }),
    ...mapMutations('Notifications', {
      addNotification: NotificationMutations.ADD_NOTIFICATION,
    }),
    removeUserIntegration: async function () {
      this.loading = true;
      try {
        await integrationService.removeUserIntegration({
          token: this.token,
          id: this.outlook!._key,
        });
        await this.fetchUserIntegrations();
        this.$emit('outlook:processed');
      } catch (error) {
        const notification = { ...error };
        this.addNotification(notification);
      } finally {
        this.loading = false;
      }
    },
  },
});
</script>

<style scoped>
.actions-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
